(function () {
  function init() {
    var form = document.getElementById('ys-gebb-form');
    if (!form) return;
    var st = document.getElementById('ys-gebb-status');
    function fertig(titel, text) {
      document.getElementById('ys-gebb-karte').innerHTML =
        '<h2 class="ys-gebb-danke">' + titel + '</h2>' +
        '<p class="ys-gebb-dankezeile">' + text + '</p>';
    }
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var tag = parseInt(document.getElementById('ys-gebb-tag').value, 10);
      var monat = parseInt(document.getElementById('ys-gebb-monat').value, 10);
      var jahr = parseInt(document.getElementById('ys-gebb-jahr').value, 10) || 0;
      if (!tag || !monat) {
        st.style.display = 'block';
        st.textContent = 'Bitte Tag und Monat auswählen.';
        return;
      }
      var knopf = document.getElementById('ys-gebb-senden');
      knopf.disabled = true;
      st.style.display = 'none';
      fetch('https://yelasai.ai/api/geburtstag.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: form.dataset.email, name: form.dataset.name,
                               tag: tag, monat: monat, jahr: jahr })
      }).then(function (r) {
        if (!r.ok) throw new Error('Fehler');
        return r.json();
      }).then(function (d) {
        var v = form.dataset.vorname || '';
        if (d && d.bereits_erfasst) {
          fertig('Dein Tag ist schon hinterlegt' + (v ? ', ' + v : ''),
                 'Wir haben deinen Geburtstag bereits notiert. Falls etwas nicht stimmt, ' +
                 'schreib uns kurz an <a href="mailto:info@yelasai.com" ' +
                 'style="color:#492365">info@yelasai.com</a> — wir korrigieren das gerne.');
        } else {
          fertig('Danke' + (v ? ', ' + v : '') + '!',
                 'Wir haben uns deinen Tag gemerkt. An deinem Geburtstag bekommst du von uns ' +
                 '<b>10&nbsp;CHF</b> geschenkt — per E-Mail, für deine nächste ' +
                 'Bestellung ab 40&nbsp;CHF Warenwert.');
        }
      }).catch(function () {
        knopf.disabled = false;
        st.style.display = 'block';
        st.textContent = 'Das hat leider nicht geklappt. Bitte versuche es gleich noch einmal.';
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
